<script setup lang="ts">
import type { IconDefinition } from '@fortawesome/fontawesome-common-types'
import { faArrowRight } from '@fortawesome/pro-light-svg-icons'

defineProps<{
  icon: IconDefinition
  label: string
  badgeCount?: number
}>()
</script>

<template>
  <button class="p-s flex items-center w-full justify-between text-primary">
    <span class="flex items-center gap-2xs text-small">
      <Icon :icon="icon" />
      {{ label }}
      <Badge
        v-if="badgeCount"
        variant="neutral"
        size="small"
        :label="String(badgeCount)"
        class="bg-blurple-300 text-inverse rounded-md shrink-0"
      />
    </span>
    <Icon :icon="faArrowRight" />
  </button>
</template>
